<template>
	<cards-view :fanzoneTypesIds='[0, 1]' url='fanzone' />
</template>

<script>
	import cardsView from '../components/CardsView'
	
	export default {
		components: { cardsView }
	}
</script>
